"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isEnterOrSpace = _interopRequireDefault(require("../../helpers/isEnterOrSpace"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Link = function Link(_ref) {
  var action = _ref.action,
      href = _ref.href,
      children = _ref.children,
      className = _ref.className,
      external = _ref.external;
  var hasLocationalHref = href && href.length > 0 && href !== '#';
  var hasCallableAction = action instanceof Function;
  var preventDefaultEvent = hasCallableAction || !hasLocationalHref;

  var handleEvent = function handleEvent(event) {
    if (preventDefaultEvent) {
      event.preventDefault();
    }

    if (hasCallableAction) {
      action(event);
    }

    if (preventDefaultEvent && hasLocationalHref) {
      if (external) {
        window.open(href);
      } else {
        window.location = href;
      }
    }
  };

  var targetProps = external ? {
    rel: 'noopener noreferrer',
    target: '_blank'
  } : null;
  return /*#__PURE__*/_react["default"].createElement("a", _extends({}, targetProps, {
    href: href,
    tabIndex: 0,
    className: "link-wrapper ".concat(className),
    onClick: handleEvent,
    onKeyPress: function onKeyPress(event) {
      return (0, _isEnterOrSpace["default"])(event) && handleEvent(event);
    }
  }), children);
};

Link.propTypes = {
  action: _propTypes["default"].func,
  href: _propTypes["default"].string.isRequired,
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element, _propTypes["default"].node, _propTypes["default"].arrayOf(_propTypes["default"].element)]).isRequired,
  external: _propTypes["default"].bool,
  className: _propTypes["default"].string
};
Link.defaultProps = {
  action: null,
  className: '',
  external: false
};
var _default = Link;
exports["default"] = _default;